import { Input } from "antd";
import React, { useEffect, useRef, useState } from "react";
import { dentalIcons } from "../../utils-icons/dentalIcons";
import "./style.css";

const CustomSearchInput = ({ onSearch, search, onSearchEnter }) => {
  const [debouncedValue, setDebouncedValue] = useState(search); // State to hold the debounced value
  const debounceTimer = useRef(null);

  const handleSearchChange = (value) => {
    setDebouncedValue(value);
    // Clear any existing timer
    if (debounceTimer.current) clearTimeout(debounceTimer.current);

    // Set a new timer
    debounceTimer.current = setTimeout(() => {
      onSearch(value); // Call the actual onSearch function after debounce delay
    }, 500); // Delay in milliseconds (300ms in this case)
  };

  useEffect(() => {
    // Cleanup timer on component unmount
    return () => {
      if (debounceTimer.current) clearTimeout(debounceTimer.current);
    };
  }, []);
  return (
    <div className="custom_search_input">
      <Input
        value={debouncedValue}
        onChange={(e) => handleSearchChange(e.target.value)}
        placeholder="Search"
      />

      <div className="seach_input_search_icon" onClick={onSearchEnter}>
        <img src={dentalIcons.searchWhite} alt="search" height={20} />
      </div>
    </div>
  );
};

export default CustomSearchInput;
